// DEPRECATED: Previously logged events to Mixpanel. Kept for backward compatibility; intentionally a no-op except console logging in DEVELOPMENT.
export default function logEvent(text, props) {
  if (process.env.REACT_APP_MODE === 'DEVELOPMENT') {
    console.log('Log Event: ', text);
  }
}
